// extracted by mini-css-extract-plugin
module.exports = {"label":"LoginForm_label__2ZIvu","input":"LoginForm_input__2UCCO","forgotPasswordLink":"LoginForm_forgotPasswordLink__3Dp2A"};